import { render, staticRenderFns } from "./d-feed-post-activity.vue?vue&type=template&id=22529977&"
import script from "./d-feed-post-activity.vue?vue&type=script&lang=js&"
export * from "./d-feed-post-activity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports